import { type DialogProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../shared/components/ModalBasic";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  childId?: string;
  onOk?: () => void;
  closeModal?: () => void;
  children?: React.ReactNode;
}

export const TransferObjectModal: FC<Props> = ({
  childId,
  onOk,
  closeModal,
  children,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <ModalBasic
      title={t("transfer_modal.title")}
      hasCloseButton
      closeModal={closeModal}
      hasFooter
      buttonOkText={t("transfer_modal.transfer_button")}
      onOk={onOk}
      onCancel={closeModal}
      {...props}
      className={styles["modal"]}
    >
      <div className={styles.container}>{children}</div>
    </ModalBasic>
  );
};
